import { ChamaDate } from "ctech-react-components";

export function parsePersistedDateFromObject<
  K extends keyof T,
  T extends Record<K, string>,
>(object: T, prop: K): void {
  if (typeof object[prop] === "string") {
    Object.assign(object, {
      [prop]: ChamaDate.fromPersistence(object[prop] || "").toView(),
    });
  }
}
